<template>
  <div class="pie-page">
    <div v-if="busy" class="d-flex flex-column align-items-center mt-8 py-6">
      <spring-spinner
        :animation-duration="1500"
        :size="60"
        color="#bf0000"
        class="mx-auto"
      />
      <p class="primary--text mx-auto font-weight-bold mt-6">
        در حال بارگذاری...
      </p>
    </div>
    <div v-else>
      <!-- header -->
      <v-card class="page-header d-flex justify-space-between py-6">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-flex flex-row">
              <img
                v-if="computedCurrentPie"
                style="width: 50px; height: 50px; border-radius: 4px"
                :src="computedCurrentPie.pictureUrl"
                class="me-3"
              />
              <h2 class="mt-2 step-m1" id="step-5">
                {{ computedCurrentPie ? computedCurrentPie.name : "نامشخص" }}
              </h2>
              <v-icon class="dark-text pt-1 px-2">mdi-chevron-down</v-icon>
            </div>
          </template>
          <div v-if="!tourActive">
            <v-list style="min-width: 200px">
              <v-list-item @click="$router.push('/add-pie')">
                <v-list-item-title
                  ><v-icon>mdi-plus-circle-outline</v-icon>ایجاد کیک سهام
                  جدید</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                v-for="(item, index) in allPies"
                :key="index"
                @click="goToPie(item)"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
        </v-menu>

        <!-- header items for desktop screen -->
        <div class="d-lg-flex d-none">
          <div v-if="role == 'manager'">
            <v-menu
              v-for="(item, index) in menu"
              :key="index"
              open-on-hover
              bottom
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="items" v-bind="attrs" v-on="on" id="step-4">
                  <v-icon class="dark-text mb-1">{{ item.icon }}</v-icon>
                  <p class="dark-text fs-medium mb-0">
                    {{ item.name }}
                    <!-- <v-icon>mdi-chevron-down</v-icon> -->
                  </p>
                </div>
              </template>
              <v-list v-if="!tourActive">
                <v-list-item
                  v-for="(item2, index) in item.children"
                  :key="index"
                  @click="
                    item2.name != 'خروج' ? $router.push(item2.link) : logout()
                  "
                >
                  <v-list-item-title v-if="item2.name != 'خروج'">
                    <v-icon>{{ item2.icon }}</v-icon>
                    {{ item2.name }}
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    <v-icon>{{ item2.icon }}</v-icon>
                    {{ item2.name }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-tooltip bottom v-if="role == 'employee'">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div
                  class="items disabled-box"
                  @click="!tourActive ? openAddDialog() : ''"
                  id="step-3"
                >
                  <v-icon class="dark-text mb-1">mdi-account-plus</v-icon>
                  <p class="dark-text fs-medium mb-0">افزودن عضو به تیم</p>
                </div>
              </div>
            </template>
            <span>تنها مدیر دسترسی به این عملیات را دارد</span>
          </v-tooltip>

          <div
            v-else
            class="items"
            @click="!tourActive ? openAddDialog() : ''"
            id="step-3"
          >
            <v-icon class="dark-text mb-1">mdi-account-plus</v-icon>
            <p class="dark-text fs-medium mb-0">افزودن عضو به تیم</p>
          </div>

          <v-tooltip bottom v-if="role == 'employee'">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div class="items disabled-box" id="step-2">
                  <v-icon class="dark-text mb-1">mdi-email-outline</v-icon>
                  <p class="dark-text fs-medium mb-0">ارسال پیام به اعضا</p>
                </div>
              </div>
            </template>
            <span>تنها مدیر دسترسی به این عملیات را دارد</span>
          </v-tooltip>

          <div
            v-else
            class="items"
            id="step-2"
            @click="!tourActive ? openMessageDialog() : ''"
          >
            <v-icon class="dark-text mb-1">mdi-email-outline</v-icon>
            <p class="dark-text fs-medium mb-0">ارسال پیام به اعضا</p>
          </div>

          <v-tooltip bottom v-if="role == 'employee'">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div
                  class="items disabled-box"
                  id="step-1"
                  @click="!tourActive ? getPieData('setting') : ''"
                >
                  <v-icon class="dark-text mb-1">mdi-cog</v-icon>
                  <p class="dark-text fs-medium mb-0">تنظیمات کیک سهام</p>
                </div>
              </div>
            </template>
            <span>تنها مدیر دسترسی به این عملیات را دارد</span>
          </v-tooltip>

          <div
            v-else
            class="items"
            id="step-1"
            @click="!tourActive ? getPieData('setting') : ''"
          >
            <v-icon class="dark-text mb-1">mdi-cog</v-icon>
            <p class="dark-text fs-medium mb-0">تنظیمات کیک سهام</p>
          </div>
        </div>
      </v-card>

      <!-- header items for mobile screen -->
      <v-card
        class="page-header d-lg-none d-flex flex-md-row flex-column justify-space-between mt-5 px-8"
      >
        <v-tooltip bottom v-if="role == 'employee'">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <div
                class="items step-m2 disabled-box"
                @click="!tourActive ? (addMemberDialog = true) : ''"
              >
                <v-icon class="dark-text mb-1">mdi-account-plus</v-icon>
                <p class="dark-text mb-0">افزودن عضو تیم</p>
              </div>
            </div>
          </template>
          <span>تنها مدیر دسترسی به این عملیات را دارد</span>
        </v-tooltip>

        <div
          v-else
          class="items step-m2"
          @click="!tourActive ? (addMemberDialog = true) : ''"
        >
          <v-icon class="dark-text mb-1">mdi-account-plus</v-icon>
          <p class="dark-text mb-0">افزودن عضو تیم</p>
        </div>

        <v-divider class="d-md-none d-block"></v-divider>

        <v-tooltip bottom v-if="role == 'employee'">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <div class="items step-m3 disabled-box">
                <v-icon class="dark-text mb-1">mdi-email-outline</v-icon>
                <p class="dark-text mb-0">ارسال پیام به اعضا</p>
              </div>
            </div>
          </template>
          <span>تنها مدیر دسترسی به این عملیات را دارد</span>
        </v-tooltip>

        <div
          v-else
          class="items step-m3"
          @click="!tourActive ? openMessageDialog() : ''"
        >
          <v-icon class="dark-text mb-1">mdi-email-outline</v-icon>
          <p class="dark-text mb-0">ارسال پیام به اعضا</p>
        </div>

        <v-divider class="d-md-none d-block"></v-divider>

        <v-tooltip bottom v-if="role == 'employee'">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <div
                class="items step-m4 disabled-box"
                @click="!tourActive ? getPieData('setting') : ''"
              >
                <v-icon class="dark-text mb-1">mdi-cog</v-icon>
                <p class="dark-text mb-0">تنظیمات کیک سهام</p>
              </div>
            </div>
          </template>
          <span>تنها مدیر دسترسی به این عملیات را دارد</span>
        </v-tooltip>

        <div
          v-else
          class="items step-m4"
          @click="!tourActive ? getPieData('setting') : ''"
        >
          <v-icon class="dark-text mb-1">mdi-cog</v-icon>
          <p class="dark-text mb-0">تنظیمات کیک سهام</p>
        </div>

        <v-divider
          class="d-md-none d-block"
          v-if="role == 'manager'"
        ></v-divider>

        <div v-if="role == 'manager'">
          <v-menu
            v-for="(item, index) in menu"
            :key="index"
            open-on-hover
            bottom
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="items step-m5" v-bind="attrs" v-on="on">
                <v-icon class="dark-text mb-1">{{ item.icon }}</v-icon>
                <p class="dark-text mb-0">
                  {{ item.name }}
                </p>
              </div>
            </template>
            <v-list v-if="!tourActive">
              <v-list-item
                v-for="(item2, index) in item.children"
                :key="index"
                @click="
                  item2.name != 'خروج' ? $router.push(item2.link) : logout()
                "
              >
                <v-list-item-title v-if="item2.name != 'خروج'">
                  <v-icon>{{ item2.icon }}</v-icon>
                  {{ item2.name }}
                </v-list-item-title>
                <v-list-item-title v-else>
                  <v-icon>{{ item2.icon }}</v-icon>
                  {{ item2.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-card>

      <v-card v-if="!hasProject" class="mt-5 primary--text">
        <v-icon class="primary--text">mdi-alert-circle-outline</v-icon>
        نوع کاری برای این کیک سهام به ثبت نرسیده است! برای ثبت نوع کار به
        <b>تنظیمات کیک سهام</b>
        مراجعه نمایید.
      </v-card>

      <!-- main content -->
      <v-row>
        <v-col md="7" cols="12">
          <v-card class="mt-5">
            <p class="text-right dark-text">اعضای تیم</p>

            <v-tabs fixed-tabs v-model="tab">
              <v-tab>فعال</v-tab>
              <v-tab
                >غیرفعال
                <div
                  style="
                    border-radius: 25px;
                    min-width: 35px;
                    height: 24px;
                    font-size: 0.8rem;
                  "
                  class="primary white--text mx-1"
                  v-if="inactiveUsers.length"
                >
                  {{ inactiveUsers.length }}
                </div>
              </v-tab>
            </v-tabs>
            <v-row class="active-members mb-3 ma-1" v-if="tourActive">
              <v-col lg="4" md="6" sm="6" cols="12" class="px-2">
                <div
                  class="member-box text-center"
                  :style="setColor('#990000')"
                >
                  <div class="image-box mb-2">
                    <v-gravatar :email="'mahyar2012@gmail.com'" />
                  </div>

                  <h3 class="name fs-xlarge">مهیار احمدپور</h3>

                  <p class="grey--text text--darken-1 fs-large">مدیر عامل</p>

                  <p class="fs-xxsmall dark-text">دقایقی پیش</p>

                  <div class="px-3 mb-4">
                    <div class="d-flex justify-space-between fs-xsmall">
                      <div>قطعات</div>
                      <div>100 (45%)</div>
                    </div>
                    <v-progress-linear
                      :value="'45'"
                      height="7"
                    ></v-progress-linear>
                  </div>

                  <div class="px-3 mb-4">
                    <div class="d-flex justify-space-between fs-xsmall">
                      <div>صندوق مالی</div>
                      <div>60%</div>
                    </div>
                    <v-progress-linear
                      :value="'60'"
                      height="7"
                    ></v-progress-linear>
                  </div>

                  <div class="px-3 mb-8">
                    <div class="d-flex justify-space-between fs-xsmall">
                      <div class="text-right">موجودی صندوق</div>
                      <div class="text-left">1،450،000،000 ریال</div>
                    </div>
                  </div>

                  <div class="footer">
                    <v-row class="px-4">
                      <v-col class="pa-1">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div id="step-6" class="step-m6">
                              <v-btn
                                class="white--text"
                                style="width: 100%; border-radius: 0 !important"
                                text
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon style="font-size: 22px"
                                  >mdi-eye</v-icon
                                ></v-btn
                              >
                            </div>
                          </template>
                          <span>اطلاعات عضو</span>
                        </v-tooltip>
                      </v-col>

                      <v-col class="pa-1">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div id="step-7" class="step-m7">
                              <v-btn
                                class="white--text"
                                style="width: 100%; border-radius: 0 !important"
                                text
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon>mdi-plus</v-icon></v-btn
                              >
                            </div>
                          </template>
                          <span>افزودن مشارکت</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-tabs-items v-model="tab" v-else>
              <!-- first tab -->
              <v-tab-item>
                <v-card class="tab-card px-1">
                  <div
                    v-if="teamLoading"
                    class="d-flex flex-column align-items-center mt-8 py-6"
                  >
                    <spring-spinner
                      :animation-duration="1500"
                      :size="60"
                      color="#bf0000"
                      class="mx-auto"
                    />
                  </div>
                  <div v-else>
                    <div
                      v-if="!activeUsers.length"
                      class="text-center dark-text mb-5"
                    >
                      عضو فعالی به ثبت نرسیده است!
                    </div>
                    <v-row v-if="!tourActive" class="active-members">
                      <v-col
                        v-for="(item, index) in activeUsers"
                        :key="index"
                        lg="4"
                        md="6"
                        sm="6"
                        cols="12"
                        class="px-2 mb-3"
                      >
                        <div
                          class="member-box text-center"
                          :style="setColor(item)"
                        >
                          <div class="image-box mb-2">
                            <img v-if="item.mediaUrl" :src="item.mediaUrl" />

                            <v-gravatar v-else :email="item.user.email" />
                          </div>

                          <h3 class="name">{{ item.name }}</h3>

                          <p class="grey--text text--darken-1 fs-large">
                            {{ item.position }}
                          </p>

                          <p class="fs-xxsmall dark-text">
                            {{ item.lastActive }}
                          </p>

                          <div class="px-3 mb-2">
                            <div class="d-flex justify-space-between fs-xsmall">
                              <div>قطعات</div>

                              <div class="py-1">
                                {{
                                  Number(
                                    item.slicesPercentage
                                  ).toLocaleString()
                                }}%
                              </div>
                            </div>
                            <v-progress-linear
                              :value="item.slicesPercentage"
                              height="7"
                            ></v-progress-linear>
                            <div class="text-left fs-xsmall pt-2">
                              {{
                                Number(
                                  item.slices / pieDetails.correctionMultiplier
                                ).toLocaleString()
                              }}
                              قطعه
                            </div>
                          </div>

                          <div class="px-3 mt-4">
                            <div class="d-flex justify-space-between fs-xsmall">
                              <div>صندوق مالی</div>
                              <div class="py-1">
                                {{
                                  Number(item.wellPercentage).toLocaleString()
                                }}%
                              </div>
                            </div>
                            <v-progress-linear
                              :value="item.wellPercentage"
                              height="7"
                            ></v-progress-linear>
                          </div>
                          <div class="px-3 mb-8 mt-0">
                            <div class="text-left fs-xsmall pt-2">
                              {{ Number(item.well).toLocaleString() }} ریال
                            </div>
                            <div
                              class="d-flex justify-space-between fs-xsmall"
                            ></div>
                          </div>

                          <div class="footer">
                            <v-row class="px-4">
                              <v-col class="pa-1">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <div>
                                      <v-btn
                                        class="white--text"
                                        style="
                                          width: 100%;
                                          border-radius: 0 !important;
                                        "
                                        text
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="openUserInfoDialog(item)"
                                        ><v-icon style="font-size: 22px"
                                          >mdi-eye</v-icon
                                        ></v-btn
                                      >
                                    </div>
                                  </template>
                                  <span>اطلاعات عضو</span>
                                </v-tooltip>
                              </v-col>

                              <v-col class="pa-1">
                                <v-tooltip
                                  top
                                  v-if="
                                    restriction == 'viewOnly' ||
                                    (role == 'employee' && ownerId != item.id)
                                  "
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                      <v-btn
                                        class="white--text"
                                        style="
                                          width: 100%;
                                          border-radius: 0 !important;
                                        "
                                        disabled
                                        text
                                        readonly
                                        ><v-icon>mdi-plus</v-icon></v-btn
                                      >
                                    </span>
                                  </template>
                                  <span
                                    >امکان ثبت مشارکت برای شما وجود ندارد</span
                                  >
                                </v-tooltip>
                                <v-tooltip top v-else>
                                  <template v-slot:activator="{ on, attrs }">
                                    <div>
                                      <v-btn
                                        class="white--text"
                                        style="
                                          width: 100%;
                                          border-radius: 0 !important;
                                        "
                                        text
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="
                                          contributionTypesDialog = true;
                                          userId = item.userId;
                                          pieUserId = item.id;
                                          userName = item.name;
                                          getPieData('contribution');
                                        "
                                        ><v-icon>mdi-plus</v-icon></v-btn
                                      >
                                    </div>
                                  </template>
                                  <span>افزودن مشارکت</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-tab-item>

              <!-- second tab -->
              <v-tab-item>
                <v-card class="tab-card px-1">
                  <div
                    v-if="!inactiveUsers.length"
                    class="text-center dark-text mb-5"
                  >
                    عضو غیرفعالی برای نمایش وجود ندارد!
                  </div>
                  <v-row class="inactive-members">
                    <v-col
                      v-for="(item, index) in inactiveUsers"
                      :key="index"
                      md="4"
                      sm="6"
                      cols="12"
                      class="px-2"
                    >
                      <div class="member-box text-center">
                        <div class="image-box">
                          <img v-if="item.mediaUrl" :src="item.mediaUrl" />

                          <v-gravatar v-else :email="item.user.email" />
                        </div>

                        <h3 class="name mt-4">{{ item.name }}</h3>

                        <p class="dark-text fs-xsmall text-right my-2 mx-4">
                          علت:
                          {{
                            reasons.filter((x) => x.value == item.reason)[0]
                              ? reasons.filter((x) => x.value == item.reason)[0]
                                  .text
                              : "-"
                          }}
                        </p>

                        <p class="fs-xsmall dark-text text-right mx-4">
                          ارزش سهام فرد:
                          {{ Number(item.buyOutPrice).toLocaleString() }} ریال
                        </p>
                        <div class="px-2">
                          <v-tooltip
                            top
                            v-if="!item.buyOutPrice || role == 'employee'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-btn
                                  @click="
                                    buyoutMemberDialog = true;
                                    selected = item;
                                    buyoutAmount = item.buyOutPrice;
                                  "
                                  disabled
                                  class="primary white--text mb-2"
                                  style="width: 100%"
                                  >تسویه حساب</v-btn
                                >
                              </span>
                            </template>
                            <span v-if="role == 'employee'"
                              >نقش شما دسترسی به این بخش را ندارد</span
                            >
                            <span v-else-if="!item.buyOutPrice"
                              >ارزش سهام فرد 0 ریال می‌باشد</span
                            >
                          </v-tooltip>
                          <div v-else>
                            <v-btn
                              @click="
                                buyoutMemberDialog = true;
                                selected = item;
                                buyoutAmount = item.buyOutPrice;
                              "
                              disabled
                              class="primary white--text mb-2"
                              style="width: 100%"
                              >تسویه حساب</v-btn
                            >
                          </div>
                          <v-tooltip top v-if="role == 'employee'">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-btn
                                  @click="
                                    rehireDialog = true;
                                    deletedName = item.name;
                                    deletedId = item.id;
                                    rehire = {};
                                  "
                                  disabled
                                  class="primary white--text mb-4"
                                  style="width: 100%"
                                  >استخدام مجدد</v-btn
                                >
                              </span>
                            </template>
                            <span>نقش شما دسترسی به این بخش را ندارد</span>
                          </v-tooltip>
                          <div v-else>
                            <v-btn
                              @click="
                                rehireDialog = true;
                                deletedName = item.name;
                                deletedId = item.id;
                                rehire = {};
                              "
                              class="primary white--text mb-4"
                              style="width: 100%"
                              >استخدام مجدد</v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
        <v-col md="5" cols="12">
          <v-card class="mt-5" style="min-height: 500px">
            <p class="text-right dark-text">مشخصات کیک سهام</p>
            <div
              v-if="chartLoading"
              class="d-flex flex-column align-items-center mt-8 py-6"
            >
              <spring-spinner
                :animation-duration="1500"
                :size="60"
                color="#bf0000"
                class="mx-auto"
              />
            </div>
            <div v-else>
              <v-tabs v-model="tab2">
                <v-tab>
                  <div
                    class="d-flex"
                    :class="
                      String(chartsInfo.totalSlices).length > 8
                        ? 'flex-column'
                        : 'flex-row'
                    "
                  >
                    <div>قطعات کیک سهام</div>
                    <div class="ms-1 d-none d-sm-none d-md-flex">
                      {{
                        tab2 == 1
                          ? "(" +
                            Number(
                              chartsInfo.totalSlices /
                                pieDetails.correctionMultiplier
                            ).toLocaleString() +
                            ")"
                          : ""
                      }}
                    </div>
                  </div>
                </v-tab>
                <v-tab>
                  <div
                    class="d-flex"
                    :class="
                      String(chartsInfo.totalWell).length > 8
                        ? 'flex-column'
                        : 'flex-row'
                    "
                  >
                    <div>ارزش صندوق مالی</div>
                    <div class="ms-1 d-none d-sm-none d-md-flex">
                      {{
                        tab2 == 0
                          ? "(" +
                            Number(chartsInfo.totalWell).toLocaleString() +
                            " ریال" +
                            ")"
                          : ""
                      }}
                    </div>
                  </div>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab2">
                <v-tab-item>
                  <div class="d-flex mt-4">
                    <span class="fs-xlarge dark-text">قطعات کیک سهام: </span>
                    <h2 class="ms-2">
                      {{
                        Number(
                          chartsInfo.totalSlices /
                            pieDetails.correctionMultiplier
                        ).toLocaleString()
                      }}
                    </h2>
                  </div>
                  <div v-if="chartsInfo.totalSlices" class="px-sm-16 py-6">
                    <Chart
                      name="pieChart"
                      type="pie"
                      :chartdata="pieData"
                      :options="optionsPie"
                      height="160"
                      v-if="!chartLoading"
                    >
                    </Chart>
                  </div>
                  <div v-else class="grey--text text--darken-1 my-2 fs-xsmall">
                    قطعه‌ای یافت نشد!
                  </div>
                </v-tab-item>

                <v-tab-item>
                  <div class="d-flex mt-4">
                    <span class="fs-xlarge dark-text">ارزش صندوق مالی: </span>
                    <h2 class="ms-2">
                      {{ Number(chartsInfo.totalWell).toLocaleString() }} ریال
                    </h2>
                  </div>
                  <div class="py-6">
                    <span
                      @click="
                        drawFundsDialog = true;
                        drawFundData = {
                          date: moment(new Date()).format('jYYYY/jMM/jDD'),
                          description: '',
                          amount: '',
                        };
                      "
                      class="pointer"
                      ><v-icon class="dark-text" large>mdi-minus-circle</v-icon>
                    </span>
                    <span
                      @click="
                        addFundsDialog = true;
                        fund = {
                          date: moment(new Date()).format('jYYYY/jMM/jDD'),
                          description: '',
                          amount: '',
                          investor: '',
                          recipient: '',
                        };
                      "
                      class="pointer"
                      ><v-icon class="dark-text" large
                        >mdi-plus-circle</v-icon
                      ></span
                    >
                    <span class="fs-large dark-text ps-3">مدیریت سرمایه</span>
                    <div v-if="chartsInfo.totalWell">
                      <Chart
                        name="barChart"
                        type="bar"
                        :chartdata="barData"
                        :options="optionsBar"
                        height="200"
                        v-if="!chartLoading"
                      >
                      </Chart>
                    </div>
                    <div
                      v-else
                      class="grey--text text--darken-1 my-4 fs-xsmall"
                    >
                      سرمایه‌ای در صندوق مالی وجود ندارد!
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- dialogs -->

    <!-- remove pie -->
    <v-dialog v-model="removeDialog" width="700">
      <v-card class="px-0">
        <v-card-title class="mb-4"> حذف کیک سهام </v-card-title>
        <v-card-text>
          <h4>آیا از حذف این کیک سهام اطمینان دارید؟</h4>
          <v-row class="mt-5">
            <v-col class="d-flex flex-row">
              <v-btn
                class="primary white--text me-3"
                @click="removePie()"
                :loading="removeLoading"
              >
                <v-icon class="me-1">mdi-check-bold</v-icon>
                بله
              </v-btn>
              <v-btn class="primary white--text" @click="removeDialog = false">
                <v-icon class="me-1">mdi-close-thick</v-icon>
                خیر
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Add member dialog -->
    <v-dialog
      v-model="addMemberDialog"
      v-if="addMemberDialog"
      width="700"
      persistent
    >
      <v-card>
        <v-card-title class="pa-2">
          <v-icon class="dark-text mb-1">mdi-account-plus</v-icon>
          <span class="fs-xlarge px-3">افزودن عضو به تیم</span>
          <span @click="addMemberDialog = false"
            ><v-icon
              style="position: absolute; top: 20px; left: 20px"
              class="dark-text mb-1 pointer"
              small
              >mdi-close</v-icon
            >
          </span>
        </v-card-title>

        <v-card-text class="pa-2 pt-4">
          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> رنگ کاربر در سامانه</label
          >
          <div class="color-box">
            <v-text-field
              v-model="newMember.color"
              outlined
              dense
              class="mt-2"
              @click="colorMenu = true"
            ></v-text-field>
            <v-menu
              offset-y
              v-model="colorMenu"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="color"
                  :style="'background-color:' + newMember.color"
                ></div>
              </template>
              <div class="pa-0">
                <v-color-picker
                  dot-size="15"
                  mode="hexa"
                  v-model="newMember.color"
                ></v-color-picker>
              </div>
            </v-menu>
          </div>

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> شماره موبایل</label
          >
          <v-text-field
            v-model="newMember.mobile"
            type="number"
            outlined
            dense
            class="mt-2"
            @input="checkNumber"
          ></v-text-field>

          <div
            v-if="wrongNum"
            class="primary--text font-weight-bold fs-xsmall"
            style="transform: translateY(-15px)"
          >
            شماره وارد‌‌شده صحیح نمی‌باشد!
          </div>

          <div
            class="dark-text font-weight-bold fs-xsmall"
            style="transform: translateY(-15px)"
            v-if="account == 'new'"
          >
            شماره موبایل در سامانه ثبت نشده است. لطفا نام و نام خانوادگی کاربر
            جدید را وارد نمایید.
          </div>
          <div
            class="dark-text font-weight-bold fs-xsmall"
            style="transform: translateY(-15px)"
            v-if="account == 'old'"
          >
            کاربر پیش از این در سامانه عضو‌‌شده است.
          </div>
          <v-row v-if="account">
            <v-col class="pb-2">
              <label class="dark-text fs-small font-weight-bold">
                <span class="primary--text">*</span> نام و نام خانوادگی</label
              >
              <v-text-field
                v-model="newMember.name"
                outlined
                dense
                class="mt-2"
                :disabled="account == 'old'"
              ></v-text-field>
            </v-col>
          </v-row>

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> عنوان شغل</label
          >
          <v-text-field
            v-model="newMember.position"
            outlined
            dense
            class="mt-2"
          ></v-text-field>

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> حقوق رایج در بازار</label
          >
          <v-row>
            <v-col sm="4" cols="12" class="pb-0 pt-5">
              <v-select
                outlined
                dense
                hide-details
                :items="rates"
                v-model="newMember.salaryRate"
              ></v-select>
            </v-col>
            <v-col class="pb-0 pt-5">
              <vuetify-money
                v-if="newMember.salaryRate == 'hourly'"
                v-model="newMember.hourlySalary"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                type="number"
                outlined
                dense
              />
              <vuetify-money
                v-else
                v-model="newMember.annualSalary"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                type="number"
                outlined
                dense
                @change="
                  newMember.hourlySalary = Number(
                    Number(newMember.annualSalary) / 2000
                  )
                "
              />
            </v-col>
          </v-row>
          <div
            v-if="newMember.salaryRate == 'annual' && newMember.annualSalary"
          >
            نرخ ساعتی این کاربر
            <b
              >{{
                Number(Number(newMember.annualSalary) / 2000).toLocaleString()
              }}
              ریال</b
            >
            می‌باشد.
          </div>
          <div
            v-if="newMember.salaryRate == 'hourly' && newMember.hourlySalary"
          >
            نرخ سالانه این کاربر
            <b>{{
              Number(Number(newMember.hourlySalary) * 2000).toLocaleString()
            }}</b>
            ریال می‌باشد.
          </div>
          <div class="mt-3">
            <label class="dark-text fs-small font-weight-bold"
              ><span class="primary--text">*</span> نوع کاربر</label
            >
            <v-radio-group v-model="newMember.accountType">
              <!-- <v-radio
                disabled
                label="ادمین (امکان افزودن، مشاهده و ویرایش مشارکت‌ها برای تمامی کاربران)"
                value="admin"
                class="mb-3 text-right"
                style="opacity: 0.7"
              ></v-radio> -->
              <v-radio
                label="مدیر (امکان افزودن مشارکت‌های شخصی و مشاهده همه مشارکت‌ها)"
                value="manager"
                class="text-right"
              ></v-radio>
              <v-radio
                label="کارمند (امکان افزودن و مشاهده مشارکت‌های شخصی)"
                value="employee"
                class="mb-3 text-right"
              ></v-radio>
            </v-radio-group>
          </div>

          <!-- <p class="primary--text font-weight-bold">
            <v-icon class="primary--text">mdi-alert-circle-outline</v-icon>
            نسخه ارائه‌‌شده MVP می‌باشد. تعیین محدودیت برای کاربر در این نسخه بی
            تاثیر خواهد بود.
          </p> -->
          <div class="mt-3">
            <label class="dark-text fs-small font-weight-bold"
              ><span class="primary--text">*</span> محدودیت</label
            >
            <v-select
              outlined
              dense
              class="mt-2"
              :items="restrictions"
              v-model="newMember.restriction"
            ></v-select>
          </div>

          <v-checkbox
            label="واجد شرایط اضافه کاری می‌باشد."
            style="font-weight: bold"
            v-model="newMember.overTime"
          ></v-checkbox>

          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-4"
          >
            <v-btn
              :disabled="
                !newMember.name ||
                !newMember.mobile ||
                !newMember.position ||
                !newMember.color ||
                !newMember.salaryRate ||
                !newMember.accountType ||
                !newMember.restriction ||
                !account
              "
              @click="addMember"
              :loading="busy"
              width="150"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
              ><v-icon small class="me-1">mdi-check</v-icon> ثبت عضو جدید</v-btn
            >
            <v-btn
              @click="addMemberDialog = false"
              width="150"
              class="primary white--text mx-sm-0 mx-auto"
              ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Send email dialog -->
    <v-dialog v-model="messageDialog" v-if="messageDialog" width="700">
      <v-card>
        <v-card-title class="pa-2">
          <v-icon class="dark-text mb-1">mdi-email-outline</v-icon>
          <span class="fs-xlarge px-3">ارسال پیام به اعضا</span>
        </v-card-title>

        <v-card-text class="pa-2 pt-4">
          <label class="dark-text fs-small font-weight-bold">موضوع</label>
          <v-text-field
            outlined
            dense
            class="mt-2"
            v-model="newText.title"
          ></v-text-field>

          <label class="dark-text fs-small font-weight-bold">متن پیام</label>
          <v-textarea
            outlined
            dense
            class="mt-2"
            v-model="newText.text"
          ></v-textarea>
          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-4"
          >
            <v-btn
              width="140"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
              @click="sendEmail"
              ><v-icon small class="me-1">mdi-check</v-icon> ارسال پیام</v-btn
            >
            <v-btn
              @click="messageDialog = false"
              width="140"
              class="primary white--text mx-sm-0 mx-auto"
              ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- user info dialog -->
    <v-dialog v-model="userInfoDialog" v-if="userInfoDialog" width="550">
      <v-card>
        <div
          v-if="modalLoading"
          class="d-flex flex-column justify-center align-center mt-8 py-6"
        >
          <spring-spinner
            :animation-duration="1500"
            :size="60"
            color="#bf0000"
            class="mx-auto mb-2"
          />
          در حال بارگذاری ...
        </div>
        <v-card-text v-else class="pa-sm-2 pa-0 pt-4">
          <div class="px-0 px-sm-6">
            <div
              class="d-flex flex-wrap justify-space-between align-center mb-sm-8 mb-3"
            >
              <div class="d-flex justify-start align-center">
                <v-gravatar :email="editMember.email" class="rounded-circle" />
                <h2 class="py-9 px-5" :style="'color: ' + editMember.color">
                  {{ editMember.name }}
                </h2>
              </div>
              <div
                class="ma-2 mt-3 chip-style px-2"
                :style="'border: 1px solid ' + editMember.color"
              >
                <div class="d-flex justify-center align-center px-4 py-1">
                  <h4 :style="'color: ' + editMember.color">
                    {{
                      editMember.accountType == "employee" ? "کارمند" : "مدیر"
                    }}
                  </h4>
                </div>
              </div>
            </div>
            <div class="ms-0 ms-sm-3 py-0">
              <div class="ms-4 fs-xsmall font-weight-bold">
                <span class="mb-5 d-flex flex-wrap justify-start align-start">
                  <v-icon class="me-2" :style="'color:' + editMember.color"
                    >mdi-briefcase-outline</v-icon
                  >
                  <h4 :style="'color: ' + editMember.color">عنوان شغل:</h4>
                  <span class="ps-2">{{ editMember.position }}</span>
                </span>
                <span class="mb-5 d-flex flex-wrap justify-start align-start">
                  <v-icon class="me-2" :style="'color:' + editMember.color"
                    >mdi-cellphone-sound</v-icon
                  >
                  <h4 :style="'color: ' + editMember.color">شماره موبایل:</h4>
                  <span class="ps-2">{{ editMember.mobile }}</span>
                </span>
                <span
                  class="mb-5 d-flex flex-wrap flex-wrap justify-start align-start"
                >
                  <v-icon class="me-2" :style="'color:' + editMember.color"
                    >mdi-email-outline</v-icon
                  >
                  <h4 :style="'color: ' + editMember.color">ایمیل:</h4>
                  <div class="ps-2">{{ editMember.email }}</div>
                </span>
                <span class="mb-5 d-flex flex-wrap justify-start align-start">
                  <v-icon class="me-2" :style="'color:' + editMember.color"
                    >mdi-account-alert-outline</v-icon
                  >
                  <h4 :style="'color: ' + editMember.color">محدودیت:</h4>
                  <span class="ps-2">{{
                    restrictions.filter(
                      (x) => x.value == editMember.restriction
                    )[0]
                      ? restrictions.filter(
                          (x) => x.value == editMember.restriction
                        )[0].text
                      : "-"
                  }}</span>
                </span>
                <span class="mb-5 d-flex flex-wrap justify-start align-start">
                  <v-icon class="me-2" :style="'color:' + editMember.color"
                    >mdi-counter</v-icon
                  >
                  <h4 :style="'color: ' + editMember.color">تعداد قطعات:</h4>
                  <span class="ps-2">{{
                    Number(editMember.sliceCount).toLocaleString()
                  }}</span>
                </span>
                <span class="mb-5 d-flex flex-wrap justify-start align-start">
                  <v-icon class="me-2" :style="'color:' + editMember.color"
                    >mdi-credit-card-outline</v-icon
                  >
                  <h4 :style="'color: ' + editMember.color">
                    میزان موجودی صندوق مالی:
                  </h4>
                  <span class="ps-2"
                    >{{
                      Number(editMember.wellBalance).toLocaleString()
                    }}
                    ریال</span
                  >
                </span>

                <span
                  class="mb-0 d-flex flex-wrap justify-start align-start"
                  v-if="editMember.hourlySalary"
                >
                  <v-icon class="me-2" :style="'color:' + editMember.color"
                    >mdi-currency-usd</v-icon
                  >
                  <h4 :style="'color: ' + editMember.color">
                    حقوق رایج در بازار:
                  </h4>
                  <span class="ps-2"
                    >{{
                      Number(editMember.hourlySalary).toLocaleString()
                    }}
                    ریال</span
                  >
                </span>
              </div>
            </div>
          </div>

          <div class="d-flex justify-end align-center mt-6">
            <div v-if="role == 'manager'">
              <v-btn
                width="100"
                class="primary white--text me-2"
                @click="openEditMemberDialog(editMember)"
                ><v-icon small class="me-1">mdi-pencil</v-icon>ویرایش</v-btn
              >
            </div>
            <v-btn
              @click="userInfoDialog = false"
              width="100"
              class="primary white--text"
              ><v-icon small class="me-1">mdi-close</v-icon>بستن</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Pie setting dialog -->
    <v-dialog
      v-model="pieSettingDialog"
      v-if="pieSettingDialog"
      width="700"
      persistent
    >
      <v-card style="overflow-x: hidden">
        <v-card-title class="pa-2">
          <span @click="pieSettingDialog = false"
            ><v-icon
              style="position: absolute; top: 20px; left: 20px"
              class="dark-text mb-1 pointer"
              small
              >mdi-close</v-icon
            >
          </span>
          <span class="fs-xlarge">تنظیمات کیک سهام</span>
        </v-card-title>
        <div
          v-if="modalLoading"
          class="d-flex flex-column align-items-center mt-8 py-6"
        >
          <spring-spinner
            :animation-duration="1500"
            :size="60"
            color="#bf0000"
            class="mx-auto"
          />
        </div>
        <v-card-text v-else class="pa-2 pt-sm-8 pt-4">
          <v-row>
            <v-col sm="3" cols="12" class="pt-2">
              <label class="dark-text fs-small font-weight-bold"
                ><span class="primary--text">*</span> نام کیک سهام:</label
              >
            </v-col>
            <v-col class="pt-0">
              <v-text-field
                outlined
                dense
                hide-details
                v-model="pieDetails.name"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-sm-8 mt-4">
            <v-col sm="3" cols="12">
              <label class="dark-text fs-small font-weight-bold">
                لوگو:
                <br />
                (طول و عرض عکس باید یکسان باشد)</label
              >
            </v-col>
            <v-col class="pt-0">
              <v-file-input
                outlined
                dense
                prepend-icon=""
                hide-details
                ref="uploadFile"
                v-model="file"
                :placeholder="
                  pieDetails.mediaId
                    ? pieDetails.mediaName
                    : 'فایلی انتخاب نشده‌ است'
                "
                @change="uploadFile(file)"
                :disabled="isUploading"
              >
                <template slot="append">
                  <v-btn
                    class="upload-btn"
                    @click="$refs.uploadFile.$refs.input.click()"
                    :disabled="isUploading"
                  >
                    <h5 class="grey--text text--darken-1">انتخاب فایل</h5>
                  </v-btn>
                </template>
              </v-file-input>
              <div v-if="isUploading" class="mt-4">
                <v-progress-linear
                  rounded
                  v-if="myFile.showProgress"
                  height="10"
                  :value="myFile.uploadPercentage"
                  class="mb-4 mt-0"
                >
                </v-progress-linear>
                در حال بارگذاری...
              </div>
            </v-col>
          </v-row>

          <v-row v-if="pieDetails.mediaUrl">
            <v-col sm="3" cols="4" class="pt-9">
              <label class="dark-text fs-small font-weight-bold">
                لوگو فعلی:</label
              >
            </v-col>
            <v-col>
              <div v-if="isUploading" class="mt-3">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <div v-else class="logo-box">
                <img :src="pieDetails.mediaUrl" />
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-8"></v-divider>

          <v-row>
            <v-col sm="6" cols="12">
              <label class="dark-text fs-small font-weight-bold"
                >ضریب غیر نقدی</label
              >
              <v-text-field
                outlined
                dense
                type="number"
                class="mt-2"
                hide-details
                v-model="pieDetails.valNonCashMultiplier"
              ></v-text-field>
            </v-col>
            <v-col sm="6" cols="12">
              <label class="dark-text fs-small font-weight-bold"
                >ضریب نقدی</label
              >
              <v-text-field
                outlined
                dense
                type="number"
                class="mt-2"
                hide-details
                v-model="pieDetails.valCashMultiplier"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-8"></v-divider>
          <v-row>
            <v-col cols="12">
              <label class="dark-text fs-small font-weight-bold"
                >ضریب اصلاح قطعات بزرگ</label
              >
              <v-text-field
                outlined
                dense
                type="number"
                class="mt-2"
                disabled
                v-model="pieDetails.correctionMultiplier"
                hint="این ضریب برای اصلاح قطعات بزرگ در هنگام نمایش استفاده میشود و قطعات سهام را بر این عدد تقسیم میکند."
                persistent-hint 
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-8"></v-divider>

          <v-row>
            <v-col sm="6" cols="12" class="pe-md-6">
              <label class="dark-text fs-small font-weight-bold"
                >نرخ کمیسیون فروش</label
              >
              <div class="d-flex justify-space-between">
                <div class="small-grey-box">0 %</div>
                <div class="small-grey-box">100 %</div>
              </div>
              <v-slider
                v-model="pieDetails.valCommission"
                hide-details
                :step="'0.5'"
                thumb-label="always"
              >
                <template v-slot:thumb-label="{ value }">
                  {{ value + " %" }}
                </template>
              </v-slider>
              <span class="dark-text">{{ pieDetails.valCommission }}% </span>
            </v-col>
            <v-col sm="6" cols="12" class="ps-md-6">
              <label class="dark-text fs-small font-weight-bold"
                >نرخ حق امتیاز</label
              >
              <div class="d-flex justify-space-between">
                <div class="small-grey-box">0 %</div>
                <div class="small-grey-box">100 %</div>
              </div>
              <v-slider
                v-model="pieDetails.valRoyalty"
                hide-details
                :step="'0.5'"
                thumb-label="always"
              >
                <template v-slot:thumb-label="{ value }">
                  {{ value + " %" }}
                </template>
              </v-slider>
              <span class="dark-text">{{ pieDetails.valRoyalty }}% </span>
            </v-col>
          </v-row>

          <v-divider class="my-8"></v-divider>

          <v-row>
            <v-col sm="6" cols="12" class="pe-md-6">
              <label class="dark-text fs-small font-weight-bold"
                >دستمزد سرمایه‌یاب</label
              >
              <div class="d-flex justify-space-between">
                <div class="small-grey-box">0 %</div>
                <div class="small-grey-box">100 %</div>
              </div>
              <v-slider
                v-model="pieDetails.valFinanceFirst"
                :step="'0.5'"
                thumb-label="always"
              >
                <template v-slot:thumb-label="{ value }">
                  {{ value + " %" }}
                </template>
              </v-slider>
              <div class="d-flex dark-text">
                <span class="pt-2 pe-2"
                  >{{ pieDetails.valFinanceFirst }}% به ازای
                </span>
                <vuetify-money
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions2"
                  type="number"
                  hide-details
                  outlined
                  dense
                  style="width: 110px"
                  v-model="pieDetails.valFinanceLimit"
                />
                <span class="ps-2 pt-2">اول سرمایه</span>
              </div>
            </v-col>
            <v-col sm="6" cols="12" class="ps-md-6">
              <label class="dark-text fs-small font-weight-bold">&nbsp;</label>
              <div class="d-flex justify-space-between">
                <div class="small-grey-box">0 %</div>
                <div class="small-grey-box">100 %</div>
              </div>
              <v-slider
                v-model="pieDetails.valFinanceSecond"
                hide-details
                :step="'0.5'"
                thumb-label="always"
              >
                <template v-slot:thumb-label="{ value }">
                  {{ value + " %" }}
                </template>
              </v-slider>
              <span class="dark-text"
                >{{ pieDetails.valFinanceSecond }}% به ازای بقیه سرمایه
              </span>
            </v-col>
          </v-row>

          <v-divider class="my-7"></v-divider>

          <label class="dark-text fs-small font-weight-bold"
            >تنظیمات مربوط به خودرو شخصی</label
          >
          <v-select
            class="mt-2"
            :class="
              pieDetails.isPieValCar &&
              pieDetails.isPieValCar != 'disablePersonalCar'
                ? 'mb-5'
                : ''
            "
            outlined
            dense
            hide-details
            :items="carSettingItems"
            v-model="pieDetails.isPieValCar"
          ></v-select>
          <!-- <label
            v-if="
              pieDetails.isPieValCar &&
              pieDetails.isPieValCar != 'disablePersonalCar'
            "
            class="dark-text fs-small font-weight-bold"
            >نرخ بازپرداخت در هر کیلومتر</label
          >
          <vuetify-money
            v-if="
              pieDetails.isPieValCar &&
              pieDetails.isPieValCar != 'disablePersonalCar'
            "
            v-model="pieDetails.valCarReimbursement"
            :valueWhenIsEmpty="whenIsEmpty"
            :options="vMoneyOptions"
            type="number"
            class="mt-2"
            hide-details
            outlined
            dense
          /> -->

          <v-divider class="my-8"></v-divider>

          <v-checkbox
            class="font-weight-bold"
            hide-details
            label="فعالسازی اضافه کاری"
            v-model="pieDetails.isPieExtraWork"
          >
          </v-checkbox>

          <v-row class="mt-5" v-if="pieDetails.isPieExtraWork">
            <v-col>
              <label class="dark-text fs-small font-weight-bold"
                >ضریب اضافه‌کاری</label
              >
              <v-text-field
                v-model="pieDetails.valExtraWork"
                type="number"
                outlined
                hide-details
                dense
                class="mt-2"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-7"></v-divider>

          <label class="dark-text fs-small font-weight-bold">انواع کار:</label>
          <div class="d-flex flex-wrap mt-4">
            <div
              v-for="(item, index) in pieDetails.projects"
              :key="index"
              class="tag-box me-2 mb-2"
            >
              {{ item }}
              <span @click="removeTag(index)" class="pointer"
                ><v-icon small>mdi-close</v-icon></span
              >
            </div>
          </div>
          <v-text-field
            outlined
            dense
            v-model="pieDetails.tag"
            placeholder="افزودن نوع کار (برای افرودن نوع کار بر روی دکمه Enter/Go کلیک کنید.)"
            @keyup.enter="pieDetails.tag ? addTag() : ''"
          ></v-text-field>
          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-4"
          >
            <div class="mb-md-0 mb-4">
              <v-btn
                @click="doEditPie()"
                :loading="busy"
                class="primary white--text"
                ><v-icon class="me-1" small>mdi-check</v-icon> ذخیره‌سازی
                تغییرات
              </v-btn>
            </div>
            <div>
              <v-btn
                @click="resetDialog = true"
                class="primary white--text me-2"
                ><v-icon class="me-1 d-md-block d-none">mdi-restore</v-icon>
                بازنشانی</v-btn
              >
              <v-btn
                @click="removeDialog = true"
                class="primary white--text me-2"
                ><v-icon class="me-1">mdi-delete-outline</v-icon> حذف</v-btn
              >
              <v-btn
                @click="pieSettingDialog = false"
                class="primary white--text"
                ><v-icon class="me-1" small>mdi-close</v-icon> لغو</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- reset pie dialog  -->
    <v-dialog v-model="resetDialog" width="700">
      <v-card class="px-0">
        <v-card-title class="mb-4"> بازنشانی/ حذف کیک سهام </v-card-title>
        <v-card-text>
          <h4>آیا از بازنشانی این کیک سهام اطمینان دارید؟</h4>
          <v-row class="mt-5">
            <v-col class="d-flex flex-row">
              <v-btn
                class="primary white--text me-3"
                @click="doReset()"
                :loading="resetLoading"
              >
                <v-icon class="me-1">mdi-check-bold</v-icon>
                <span>بله</span>
              </v-btn>
              <v-btn class="primary white--text" @click="resetDialog = false">
                <v-icon class="me-1">mdi-close-thick</v-icon>
                خیر
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- contribution types dialog -->
    <v-dialog
      v-model="contributionTypesDialog"
      v-if="contributionTypesDialog"
      width="700"
    >
      <v-card>
        <v-card-title class="pa-2">
          <span @click="contributionTypesDialog = false"
            ><v-icon
              style="position: absolute; top: 20px; left: 20px"
              class="dark-text mb-1 pointer"
              small
              >mdi-close</v-icon
            >
          </span>
          <span class="fs-xlarge">انتخاب نوع مشارکت</span>
        </v-card-title>

        <v-card-text class="pa-2 pt-4">
          <span class="primary--text fs-medium">
            <v-icon class="primary--text">mdi-flare</v-icon> افزودن مشارکت برای
            <b>{{ userName }}</b>
          </span>
          <div class="contribution-types mt-6">
            <div
              v-for="(item, index) in computedTypes"
              :key="index"
              class="py-2"
              :style="
                index != computedTypes.length - 1
                  ? 'border-bottom: 1px solid #ccc'
                  : ''
              "
            >
              <v-btn
                @click="
                  openContributionDialog(item);
                  item.title == 'زمان' ? getUserInfo() : '';
                  refresh = !refresh;
                "
                text
                style="width: 100%"
                height="63"
              >
                <div class="px-3 me-auto" style="width: fit-content">
                  <v-icon class="me-3 dark-text">{{ item.icon }}</v-icon>
                  <span class="fs-large dark-text">{{ item.title }}</span>
                </div>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- contribution dialog -->
    <v-dialog
      v-model="contributionDialog"
      v-if="contributionDialog"
      width="700"
    >
      <v-card>
        <v-card-title class="pa-2">
          <span @click="contributionDialog = false"
            ><v-icon
              style="position: absolute; top: 20px; left: 20px"
              class="dark-text mb-1 pointer"
              small
              >mdi-close</v-icon
            >
          </span>
          <span class="fs-xlarge"
            ><v-icon>{{ selectedType.icon }}</v-icon>
            {{ selectedType.title }}</span
          >
        </v-card-title>

        <v-card-text class="pa-2 pt-4">
          <span class="primary--text fs-medium">
            <v-icon class="primary--text">mdi-flare</v-icon> افزودن مشارکت برای
            <b>{{ userName }}</b>
          </span>
          <div class="mt-6">
            <Time
              v-if="selectedType.title == 'زمان'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :hourlySalary="userHourlySalary"
              :userOverTime="userOverTime"
              :refresh="refresh"
            />
            <Expense
              v-if="selectedType.title == 'هزینه‌ها'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <Supplies
              v-if="selectedType.title == 'منابع'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <Equipment
              v-if="selectedType.title == 'تجهیزات'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <Sales
              v-if="selectedType.title == 'فروش'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <Royalty
              v-if="selectedType.title == 'حق امتیاز'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <Facilities
              v-if="selectedType.title == 'امکانات'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <FinderFee
              v-if="selectedType.title == 'دستمزد سرمایه‌یاب'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <Car
              v-if="selectedType.title == 'اتومبیل شخصی'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              :pieDetails="pieDetails"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :refresh="refresh"
            />
            <Other
              v-if="selectedType.title == 'سایر موارد'"
              @closeDialog="doCloseDialog()"
              :userId="userId"
              :pieUserId="pieUserId"
              @getInfo="getInfo()"
              @closeMain="closeMainDialog()"
              :pieDetails="pieDetails"
              :refresh="refresh"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- member setting dialog -->
    <v-dialog
      v-model="editMemberDialog"
      v-if="editMemberDialog"
      width="800"
      persistent
    >
      <v-card>
        <v-card-title class="pa-2">
          <v-icon class="dark-text mb-1">mdi-cog</v-icon>
          <span class="fs-xlarge px-3"
            >تنظیمات: {{ editMember.name }}
            <span v-if="editMember.mobile"
              >({{ editMember.mobile }})</span
            ></span
          >
          <span @click="editMemberDialog = false"
            ><v-icon
              style="position: absolute; top: 20px; left: 20px"
              class="dark-text mb-1 pointer"
              small
              >mdi-close</v-icon
            >
          </span>
        </v-card-title>
        <v-card-text class="pa-2 pt-4">
          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> رنگ کاربر در سامانه</label
          >
          <div class="color-box">
            <v-text-field
              v-model="editMember.color"
              outlined
              dense
              class="mt-2"
              @click="colorMenu2 = true"
            ></v-text-field>
            <v-menu
              offset-y
              v-model="colorMenu2"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="color"
                  :style="'background-color:' + editMember.color"
                ></div>
              </template>
              <div class="pa-0">
                <v-color-picker
                  dot-size="15"
                  mode="hexa"
                  v-model="editMember.color"
                ></v-color-picker>
              </div>
            </v-menu>
          </div>

          <label class="dark-text fs-small font-weight-bold"> عنوان شغل</label>
          <v-text-field
            v-model="editMember.position"
            outlined
            dense
            class="mt-2"
          ></v-text-field>

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> حقوق رایج در بازار</label
          >
          <v-row>
            <v-col sm="4" cols="12" class="pb-0 pt-5">
              <v-select
                outlined
                dense
                hide-details
                :items="rates"
                v-model="editMember.salaryRate"
              ></v-select>
            </v-col>
            <v-col class="pb-0 pt-5">
              <vuetify-money
                v-if="editMember.salaryRate == 'hourly'"
                v-model="editMember.hourlySalary"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                type="number"
                outlined
                dense
              />
              <vuetify-money
                v-else
                v-model="editMember.annualSalary"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                type="number"
                outlined
                dense
                @change="
                  editMember.hourlySalary = Number(
                    Number(editMember.annualSalary) / 2000
                  )
                "
              />
            </v-col>
          </v-row>
          <div
            v-if="editMember.salaryRate == 'annual' && editMember.annualSalary"
          >
            نرخ ساعتی این کاربر
            <b
              >{{
                Number(Number(editMember.annualSalary) / 2000).toLocaleString()
              }}
              ریال</b
            >
            می‌باشد.
          </div>
          <div
            v-if="editMember.salaryRate == 'hourly' && editMember.hourlySalary"
          >
            نرخ سالانه این کاربر
            <b>{{
              Number(Number(editMember.hourlySalary) * 2000).toLocaleString()
            }}</b>
            ریال می‌باشد.
          </div>

          <div class="mt-3">
            <label class="dark-text fs-small font-weight-bold">
              نوع کاربر</label
            >
            <v-select
              v-model="editMember.accountType"
              :items="types"
              outlined
              dense
              class="mt-2"
            ></v-select>
          </div>
          <div>
            <!-- <p class="primary--text font-weight-bold">
              <v-icon class="primary--text">mdi-alert-circle-outline</v-icon>
              نسخه ارائه‌‌شده MVP می‌باشد. تعیین محدودیت برای کاربر در این نسخه
              بی تاثیر خواهد بود.
            </p> -->
            <label class="dark-text fs-small font-weight-bold"> محدودیت</label>
            <v-select
              outlined
              dense
              class="mt-2"
              :items="restrictions"
              v-model="editMember.restriction"
            ></v-select>
          </div>

          <v-checkbox
            v-if="editMember.pieOverTime"
            label="واجد شرایط اضافه کاری می‌باشد."
            style="font-weight: bold"
            v-model="editMember.overTime"
          ></v-checkbox>

          <div class="mb-10">
            <v-row>
              <v-col md="6" cols="12">
                <v-btn
                  @click="openLumpSumDialog()"
                  height="90"
                  class="bordered-btn"
                  style="width: 100%"
                >
                  <div class="d-flex flex-column">
                    <v-icon>mdi-currency-usd</v-icon>
                    <p class="mb-0 font-weight-bold">برداشت‌ با حجم بالا</p>
                  </div>
                </v-btn>
              </v-col>
              <v-col
                md="6"
                cols="12"
                v-if="role == 'manager' && ownerId != editMember.id"
              >
                <v-btn
                  @click="
                    editMemberDialog = false;
                    removeMemberDialog = true;
                    removeReason = '';
                  "
                  height="90"
                  class="bordered-btn"
                  style="width: 100%"
                >
                  <div class="d-flex flex-column">
                    <v-icon>mdi-account-cancel</v-icon>
                    <p class="mb-0 font-weight-bold">حذف عضو از تیم</p>
                  </div>
                </v-btn>
              </v-col>
              <!-- <v-col md="4" cols="12" v-if="accountType != 'admin'">
                <v-btn
                  @click="
                    infoDialog = true;
                    infoTitle = 'دعوت دوباره عضو';
                  "
                  height="90"
                  class="bordered-btn"
                  style="width: 100%"
                >
                  <div class="d-flex flex-column">
                    <v-icon>mdi-email-outline</v-icon>
                    <p class="mb-0 font-weight-bold">دعوت دوباره عضو</p>
                  </div>
                </v-btn>
              </v-col> -->
            </v-row>
          </div>

          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-4"
          >
            <v-btn
              :disabled="
                !editMember.position ||
                !editMember.salaryRate ||
                !editMember.accountType ||
                !editMember.restriction
              "
              @click="doEditMember"
              :loading="busy"
              width="150"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
              ><v-icon small class="me-1">mdi-check</v-icon> ذخیره‌سازی
              تغییرات</v-btn
            >
            <v-btn
              @click="editMemberDialog = false"
              width="150"
              class="primary white--text mx-sm-0 mx-auto"
              ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- remove member dialog -->
    <v-dialog
      v-model="removeMemberDialog"
      v-if="removeMemberDialog"
      width="700"
    >
      <v-card>
        <v-card-title class="pa-2">
          <v-icon class="dark-text mb-1">mdi-account-cancel</v-icon>
          <span class="fs-xlarge px-3">حذف عضو از تیم</span>
        </v-card-title>

        <v-card-text class="pa-2 pt-4">
          <v-radio-group v-model="removeReason">
            <v-radio
              style="font-weight: bold"
              label="فسخ با دلیل قانع‌کننده"
              value="Terminate for Good Reason"
              class="mb-3"
            ></v-radio>
            <v-radio
              style="font-weight: bold"
              label="فسخ بدون دلیل قانع‌کننده"
              value="Terminate for No Good Reason"
              class="mb-3"
            ></v-radio>
            <v-radio
              style="font-weight: bold"
              label="استعفا با دلیل قانع‌کننده"
              value="Resign for Good Reason"
            ></v-radio>
            <v-radio
              style="font-weight: bold"
              label="استعفا بدون دلیل قانع‌کننده"
              value="Resign for No Good Reason"
            ></v-radio>
          </v-radio-group>
          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-4"
          >
            <v-btn
              :disabled="!removeReason"
              @click="removeMember()"
              :loading="busy"
              width="150"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
              ><v-icon small class="me-1">mdi-check</v-icon>
              حذف
            </v-btn>
            <v-btn
              @click="removeMemberDialog = false"
              width="150"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0"
              ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- create lumpSumPayment dialog -->
    <v-dialog
      v-model="lumpSumPaymentDialog"
      v-if="lumpSumPaymentDialog"
      width="700"
    >
      <v-card>
        <v-card-title class="pa-2">
          <v-icon class="dark-text mb-1">mdi-currency-usd</v-icon>
          <span class="fs-xlarge px-3">برداشت با حجم بالا</span>
        </v-card-title>

        <v-card-text class="pa-2 pt-4">
          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> تاریخ</label
          >
          <span id="theDate">
            <v-text-field
              outlined
              dense
              class="mt-2"
              v-model="payment.date"
              prepend-inner-icon="mdi-calendar-month"
            ></v-text-field>
          </span>
          <date-picker
            element="theDate"
            v-model="payment.date"
            color="#bf0000"
          ></date-picker>

          <label class="dark-text fs-small font-weight-bold">توضیحات</label>
          <v-textarea
            outlined
            dense
            class="mt-2"
            rows="3"
            v-model="payment.description"
          ></v-textarea>

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> مقدار برداشت با حجم بالا
            <br />
            <span class="primary--text fs-xxsmall"
              >مجموع ارزش قطعات و موجودی صندوق کاربر:
              <b
                >{{ Number(computedSumOfWellSlice).toLocaleString() }} ریال</b
              ></span
            >
          </label>
          <vuetify-money
            v-model="payment.amount"
            :valueWhenIsEmpty="whenIsEmpty"
            :options="vMoneyOptions"
            type="number"
            outlined
            dense
            class="mt-2"
          />
          <div
            v-if="Number(payment.amount) > Number(computedSumOfWellSlice)"
            class="red--text font-weight-bold fs-xsmall"
            style="transform: translateY(-15px)"
          >
            مبلغ وارد‌‌شده بیشتر از مبلغ مجاز است!
          </div>
          <div
            v-if="computedInvalidAmount"
            class="red--text font-weight-bold fs-xsmall"
            style="transform: translateY(-15px)"
          >
            مبلغ وارد‌‌شده از موجودی صندوق کاربران دیگر بیشتر است.
          </div>
          <div class="font-weight-bold mb-4">
            <v-icon>mdi-alert-outline</v-icon> توجه داشته باشید که ارزش قطعات از
            موجودی صندوق کاربرانی به جز کاربر کنونی پرداخت‌‌شده و موجودی صندوق
            کاربر از موجودی خود کاربر کسر می‌شود.
          </div>
        </v-card-text>
        <div class="d-flex flex-sm-row flex-column justify-space-between">
          <v-btn
            :disabled="
              !payment.date ||
              !payment.amount ||
              Number(payment.amount) > Number(computedSumOfWellSlice) ||
              computedInvalidAmount
            "
            @click="addLumpSum()"
            :loading="lumpSumBusy"
            width="150"
            class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
            ><v-icon small class="me-1">mdi-check</v-icon> کاهش قطعات</v-btn
          >
          <v-btn
            @click="lumpSumPaymentDialog = false"
            width="150"
            class="primary white--text mx-sm-0 mx-auto"
            ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <!-- buyout member dialog -->
    <v-dialog
      v-model="buyoutMemberDialog"
      v-if="buyoutMemberDialog"
      width="450"
    >
      <v-card>
        <v-card-title class="pa-2">
          <span @click="buyoutMemberDialog = false"
            ><v-icon
              style="position: absolute; top: 20px; left: 20px"
              class="dark-text mb-1 pointer"
              small
              >mdi-close</v-icon
            >
          </span>
          <span class="fs-xlarge px-3"
            >تسویه حساب با <b>{{ selected.name }}</b></span
          >
        </v-card-title>

        <v-card-text class="pa-2 pt-6">
          <div class="text-center">
            <div class="text-right">
              <span class="primary--text fs-xxsmall"
                >موجودی صندوق:
                <b
                  >{{ Number(chartsInfo.totalWell).toLocaleString() }} ریال</b
                ></span
              >
              <vuetify-money
                v-model="buyoutAmount"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                type="number"
                outlined
                dense
                class="mt-2"
              />
              <div
                v-if="computedAmount3"
                class="red--text font-weight-bold fs-xsmall"
                style="transform: translateY(-15px)"
              >
                مبلغ وارد‌‌شده از موجودی صندوق بیشتر می‌باشد!
              </div>
              <div
                v-if="computedAmount4"
                class="red--text font-weight-bold fs-xsmall"
                style="transform: translateY(-15px)"
              >
                مبلغ وارد‌‌شده نمی‌تواند از ارزش سهام فرد بیشتر باشد!
              </div>
            </div>
            <div style="transform: translateY(-25px)">
              <v-checkbox
                v-model="payFromWell"
                label="مبلغ پرداختی از صندوق مالی کسر شود"
              >
              </v-checkbox>
            </div>
            <div>
              <v-btn
                @click="doBuyout(selected)"
                :loading="buyoutBusy"
                :disabled="computedAmount3 || computedAmount4"
                class="primary white--text"
                >تسویه حساب</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- re-hire dialog -->
    <v-dialog v-model="rehireDialog" v-if="rehireDialog" width="600">
      <v-card>
        <v-card-title class="pa-2">
          <span class="fs-xlarge px-3">استخدام مجدد کاربر</span>
        </v-card-title>
        <v-card-text class="pa-2 pt-6">
          <div>
            <label class="dark-text fs-small font-weight-bold"
              ><span class="primary--text">*</span> تعداد قطعات
            </label>
            <vuetify-money
              v-model="rehire.sliceCount"
              :valueWhenIsEmpty="whenIsEmpty"
              :options="vMoneyOptions2"
              type="number"
              outlined
              dense
              class="mt-2"
            />

            <label class="dark-text fs-small font-weight-bold"
              ><span class="primary--text">*</span> صندوق مالی
              <br />
              <span class="primary--text fs-xxsmall"
                >موجودی صندوق:
                <b
                  >{{ Number(chartsInfo.totalWell).toLocaleString() }} ریال</b
                ></span
              >
            </label>
            <vuetify-money
              v-model="rehire.wellBalance"
              :valueWhenIsEmpty="whenIsEmpty"
              :options="vMoneyOptions"
              type="number"
              outlined
              dense
              class="mt-2"
            />
            <div
              v-if="computedAmount2"
              class="red--text font-weight-bold fs-xsmall"
              style="transform: translateY(-15px)"
            >
              مبلغ وارد‌‌شده از موجودی صندوق بیشتر می‌باشد!
            </div>
          </div>
          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-10"
          >
            <v-btn
              @click="rehireMember()"
              :loading="busy"
              :disabled="computedAmount2"
              width="150"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
              ><v-icon small class="me-1">mdi-check</v-icon> تایید</v-btn
            >
            <v-btn
              @click="rehireDialog = false"
              width="150"
              class="primary white--text mx-sm-0 mx-auto"
              ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- add funds dialog -->
    <v-dialog v-model="addFundsDialog" v-if="addFundsDialog" width="700">
      <v-card>
        <v-card-title class="pa-2">
          <v-icon>mdi-plus-circle</v-icon>
          <span class="fs-xlarge px-3">افزودن سرمایه به صندوق</span>
        </v-card-title>

        <v-card-text class="pa-2 pt-6">
          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> تاریخ</label
          >
          <span id="theDate2">
            <v-text-field
              outlined
              dense
              class="mt-2"
              v-model="fund.date"
              prepend-inner-icon="mdi-calendar-month"
            ></v-text-field>
          </span>
          <date-picker
            element="theDate2"
            v-model="fund.date"
            color="#bf0000"
          ></date-picker>

          <label class="dark-text fs-small font-weight-bold">توضیحات</label>
          <v-textarea
            outlined
            dense
            class="mt-2"
            rows="3"
            v-model="fund.description"
          ></v-textarea>

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> مبلغ</label
          >
          <vuetify-money
            v-model="fund.amount"
            :valueWhenIsEmpty="whenIsEmpty"
            :options="vMoneyOptions"
            type="number"
            outlined
            dense
            class="mt-2"
          />

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> سرمایه‌گذار</label
          >
          <v-select
            outlined
            dense
            :items="activeUsers"
            v-model="fund.fundUserId"
            class="mt-2"
            item-text="name"
            item-value="id"
          ></v-select>
          <label class="dark-text fs-small font-weight-bold"
            >یابنده سرمایه‌گذار (اختیاری)</label
          >
          <v-select
            outlined
            dense
            :items="activeUsers"
            v-model="fund.finderId"
            item-text="name"
            item-value="id"
            class="mt-2"
          ></v-select>

          <div v-if="computedPerson" class="primary--text font-weight-bold">
            <v-icon class="primary--text">mdi-alert-outline</v-icon> سرمایه‌گذار
            و یابنده سرمایه‌گذار نمی‌توانند یکسان باشند!
          </div>

          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-10"
          >
            <v-btn
              :loading="fundBusy"
              width="150"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
              @click="addFund()"
              :disabled="
                !fund.date || !fund.amount || !fund.fundUserId || computedPerson
              "
              ><v-icon small class="me-1">mdi-check</v-icon> افزودن
              سرمایه</v-btn
            >
            <v-btn
              @click="addFundsDialog = false"
              width="150"
              class="primary white--text mx-sm-0 mx-auto"
              ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- draw funds dialog -->
    <v-dialog v-model="drawFundsDialog" v-if="drawFundsDialog" width="700">
      <v-card>
        <v-card-title class="pa-2">
          <v-icon>mdi-minus-circle</v-icon>
          <span class="fs-xlarge px-3">برداشت سرمایه از صندوق</span>
        </v-card-title>

        <v-card-text class="pa-2 pt-6">
          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> تاریخ</label
          >
          <span id="theDate3">
            <v-text-field
              outlined
              dense
              class="mt-2"
              v-model="drawFundData.date"
              prepend-inner-icon="mdi-calendar-month"
            ></v-text-field>
          </span>
          <date-picker
            element="theDate3"
            v-model="drawFundData.date"
            color="#bf0000"
          ></date-picker>

          <label class="dark-text fs-small font-weight-bold"
            ><span class="primary--text">*</span> مبلغ
            <br />
            <span class="primary--text fs-xxsmall"
              >موجودی صندوق:
              <b
                >{{ Number(chartsInfo.totalWell).toLocaleString() }} ریال</b
              ></span
            >
          </label>
          <vuetify-money
            v-model="drawFundData.amount"
            :valueWhenIsEmpty="whenIsEmpty"
            :options="vMoneyOptions"
            type="number"
            outlined
            dense
            class="mt-2"
          />
          <div
            v-if="computedAmount"
            class="red--text font-weight-bold fs-xsmall"
            style="transform: translateY(-15px)"
          >
            مبلغ وارد‌‌شده از موجودی صندوق بیشتر می‌باشد!
          </div>

          <label class="dark-text fs-small font-weight-bold">توضیحات</label>
          <v-textarea
            outlined
            dense
            class="mt-2"
            rows="3"
            v-model="drawFundData.description"
          ></v-textarea>

          <div
            class="d-flex flex-sm-row flex-column justify-space-between mt-10"
          >
            <v-btn
              :disabled="
                !drawFundData.date || !drawFundData.amount || computedAmount
              "
              :loading="busy"
              width="150"
              class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
              @click="drawFund()"
              ><v-icon small class="me-1">mdi-check</v-icon> برداشتن
              سرمایه</v-btn
            >
            <v-btn
              @click="drawFundsDialog = false"
              width="150"
              class="primary white--text mx-sm-0 mx-auto"
              ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- mvp dialog -->
    <v-dialog v-model="infoDialog" max-width="700">
      <v-card class="pa-2">
        <v-card-title class="mb-4">{{ infoTitle }}</v-card-title>
        <v-card-text class="px-2"> <MVPInfo /> </v-card-text>
        <v-card-actions>
          <v-btn class="ms-auto primary white--text" @click="infoDialog = false"
            >فهمیدم!</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tour
      name="myTour"
      :steps="mySteps"
      :options="myOptions"
      :callbacks="myCallbacks"
    ></v-tour>
  </div>
</template>

<script>
const Chart = () => import("@/components/charts/Chart");
const Time = () => import("@/components/contributionTypes/Time");
const Sales = () => import("@/components/contributionTypes/Sales");
const Other = () => import("@/components/contributionTypes/Other");
const Royalty = () => import("@/components/contributionTypes/Royalty");
const Expense = () => import("@/components/contributionTypes/Expense");
const Supplies = () => import("@/components/contributionTypes/Supplies");
const FinderFee = () => import("@/components/contributionTypes/FinderFee");
const Equipment = () => import("@/components/contributionTypes/Equipment");
const Facilities = () => import("@/components/contributionTypes/Facilities");
const Car = () => import("@/components/contributionTypes/Car");
const MVPInfo = () => import("@/components/MVPInfo");
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { SpringSpinner } from "epic-spinners";
export default {
  components: {
    Chart,
    Time,
    Sales,
    Other,
    Expense,
    Royalty,
    Supplies,
    FinderFee,
    Equipment,
    Facilities,
    Car,
    datePicker: VuePersianDatetimePicker,
    SpringSpinner,
    MVPInfo,
  },
  data() {
    return {
      resetDialog: false,

      newText: [],
      role: "",
      ownerId: "",
      lastVisit: "",
      mySteps: [],
      tourActive: false,
      restriction: "",
      myOptions: {
        useKeyboardNavigation: false,
        highlight: true,
        labels: {
          buttonSkip: "رد کردن",
          buttonPrevious: " برو قبلی",
          buttonNext: "برو بعدی",
          buttonStop: "متوجه شدم",
        },
      },
      desktopSteps: [
        {
          target: "#step-1",
          // mahur
          content: `<strong>تنظیمات کیک سهام</strong>!`,
          params: {
            highlight: true,
            enableScrolling: false,
          },
          before: (type) =>
            new Promise((resolve, reject) => {
              this.tourActive = true;
              resolve("foo");
            }),
        },
        {
          target: "#step-2",
          // mahur
          content: `<strong>ارسال پیام به اعضا</strong>!`,
          params: {
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: "#step-3",
          // mahur
          content: `<strong>افزودن عضو تیم</strong>!`,
          params: {
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: "#step-4",
          // mahur
          content: `<strong>مشاهده گزارش ها</strong>!`,
          params: {
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: "#step-5",
          // mahur
          content: `<strong>ایجاد کیک سهام جدید</strong>!`,
          params: {
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: "#step-6",
          // mahur
          content: `<strong>تنظیمات کاربر</strong>!`,
          params: {
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: "#step-7",
          // mahur
          content: `<strong>افزودن مشارکت</strong>!`,
          params: {
            highlight: true,
            enableScrolling: false,
          },
        },
        // {
        //   target: "#step-8",
        //   // mahur
        //   content: `متن <strong>تستی</strong>!`,
        //   params: {
        //     highlight: false,
        //     enableScrolling: false,
        //   },
        // },
      ],
      mobileSteps: [
        {
          target: ".step-m1",
          // mahur
          content: `<strong>ایجاد کیک سهام جدید</strong>!`,
          params: {
            highlight: true,
            enableScrolling: true,
          },
          offset: -50,
          before: (type) =>
            new Promise((resolve, reject) => {
              this.tourActive = true;
              resolve("foo");
            }),
        },
        {
          target: ".step-m2",
          // mahur
          content: `<strong>افزودن عضو تیم</strong>!`,
          params: {
            highlight: true,
            enableScrolling: true,
          },
          offset: -50,
        },
        {
          target: ".step-m3",
          // mahur
          content: `<strong>ارسال پیام به اعضا</strong>!`,
          params: {
            highlight: true,
            enableScrolling: true,
          },
          offset: -50,
        },
        {
          target: ".step-m4",
          // mahur
          content: `<strong>تنظیمات کیک سهام</strong>!`,
          params: {
            highlight: true,
            enableScrolling: true,
          },
          offset: -50,
        },
        {
          target: ".step-m5",
          // mahur
          content: `<strong>مشاهده گزارش ها</strong>!`,
          params: {
            highlight: true,
            enableScrolling: true,
          },
          offset: -50,
        },
        {
          target: ".step-m6",
          // mahur
          content: `<strong>تنظیمات کاربر</strong>!`,
          params: {
            highlight: true,
            enableScrolling: true,
          },
          offset: -50,
        },
        {
          target: ".step-m7",
          // mahur
          content: `<strong>افزودن مشارکت</strong>!`,
          params: {
            highlight: true,
            enableScrolling: true,
          },
          offset: -50,
        },
        // {
        //   target: "#step-8",
        //   // mahur
        //   content: `متن <strong>تستی</strong>!`,
        //   params: {
        //     highlight: false,
        //     enableScrolling: false,
        //   },
        // },
      ],
      myCallbacks: {
        onSkip: this.endtour,
        onFinish: this.endtour,
        onStop: this.endtour,
      },
      moment: moment,
      rates: [
        {
          text: "درآمد سالیانه",
          value: "annual",
        },
        {
          text: "نرخ ساعتی",
          value: "hourly",
        },
      ],
      restrictions: [
        { text: "بدون محدودیت", value: "none" },
        { text: "برای مشارکت نیاز به تایید دارد", value: "requireApproval" },
        { text: "فقط امکان مشاهده دارد", value: "viewOnly" },
      ],
      carSettingItems: [
        { text: "غیرفعال‌سازی خودرو شخصی", value: "disablePersonalCar" },
        { text: "در نظر گرفتن به عنوان مشارکت نقدی", value: "treatAsCash" },
        // {
        //   text: "در نظر گرفتن به عنوان مشارکت غیر نقدی",
        //   value: "treatAsNonCash",
        // },
        // { text: "نرخ ترکیبی", value: "spilitRate" },
      ],
      types: [
        // { text: "ادمین", value: "admin", disabled: true },
        { text: "مدیر", value: "manager" },
        { text: "کارمند", value: "employee" },
      ],
      tab: null,
      tab2: null,
      rehireDialog: false,
      messageDialog: false,
      addFundsDialog: false,
      drawFundsDialog: false,
      addMemberDialog: false,
      editMemberDialog: false,
      pieSettingDialog: false,
      buyoutMemberDialog: false,
      removeMemberDialog: false,
      contributionDialog: false,
      lumpSumPaymentDialog: false,
      contributionTypesDialog: false,
      userInfoDialog: false,
      removeReason: "",
      contributionTypes: [],
      newMember: {
        name: "",
        mobile: "",
        position: "",
        salaryRate: "",
        annualSalary: "",
        hourlySalary: "",
        accountType: "",
        restriction: "none",
        color: "#bf0000",
      },
      editMember: {
        name: "",
        position: "",
        salaryRate: "",
        annualSalary: "",
        hourlySalary: "",
        accountType: "",
        color: "",
        restriction: "none",
      },
      pieDetails: {
        carSetting: "disable",
        correctionMultiplier: 1000000,
        projects: [],
      },
      selected: {},
      selectedType: {},
      payment: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
      },
      rehire: {},
      busy: false,
      buyoutAmount: "",
      payFromWell: false,
      pieData: {},
      barData: {},
      chartsInfo: {},
      chartLoading: false,
      optionsPie: {
        responsive: true,
        maintainAspectRatio: true,
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
        plugins: {
          legend: {
            rtl: true,
            display: true,
            position: "bottom",
            labels: {
              font: {
                family: "iransans",
                weight: "bold",
              },
              boxWidth: 25,
              boxHeight: 12,
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
            callbacks: {
              label(tooltipItems) {
                return `${tooltipItems.label}: ${tooltipItems.formattedValue} قطعه`;
              },
            },
          },
        },
        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            display: false,
            min: 0,
            title: {
              display: true,
              font: { family: "iransans" },
            },
            grid: {
              display: false,
            },
            ticks: {
              stepSize: 1,
              beginAtZero: true,
              font: { family: "iransans" },
            },
          },
          x: {
            display: false,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      optionsBar: {
        responsive: true,
        maintainAspectRatio: true,
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
        plugins: {
          legend: {
            rtl: true,
            display: false,
            position: "bottom",
            labels: {
              font: {
                family: "iransans",
                weight: "bold",
              },
              boxWidth: 25,
              boxHeight: 12,
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
            callbacks: {
              label(tooltipItems) {
                return `${tooltipItems.formattedValue} ریال`;
              },
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            min: 0,
            title: {
              display: true,
              font: { family: "iransans" },
            },
            grid: {
              display: true,
            },
            ticks: {
              stepSize: 10000,
              beginAtZero: true,
              font: { family: "iransans" },
            },
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      fund: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
        fundUserId: "",
        finderId: "",
      },
      drawFundData: {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
      },
      fundBusy: false,
      drawBusy: false,
      teamLoading: false,
      modalLoading: false,
      activeUsers: [],
      inactiveUsers: [],
      allPies: [],
      pieAllData: {},
      userId: "",
      pieUserId: "",
      userName: "",
      boxColor: "rgba(191,0,0,1)",
      infoDialog: false,
      infoTitle: "",
      reasons: [
        { value: "Terminate for Good Reason", text: "فسخ با دلیل قانع‌کننده" },
        {
          value: "Terminate for No Good Reason",
          text: "فسخ بدون دلیل قانع‌کننده",
        },
        { value: "Resign for Good Reason", text: "استعفا با دلیل قانع‌کننده" },
        {
          value: "Resign for No Good Reason",
          text: "استعفا بدون دلیل قانع‌کننده",
        },
      ],
      deletedName: "",
      deletedId: "",
      rehireBusy: false,
      buyoutBusy: false,
      accountType: "",
      userHourlySalary: "",
      userOverTime: "",
      refresh: false,
      lumpSumBusy: false,
      hasProject: true,
      wrongNum: false,
      interval: "",
      account: "",
      show: false,
      colorMenu: false,
      colorMenu2: false,
      resetLoading: false,

      //file
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      isUploading: false,
      removeDialog: false,
      removeLoading: false,
      resetLoading: false,
    };
  },
  methods: {
    sendEmail() {
      this.$http
        .post(
          this.baseUrl + "/manager/news/new/" + this.$route.params.id,
          {
            title: this.newText.title,
            text: this.newText.text,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.messageDialog = false;
            this.newText.title = "";
            this.newText.text = "";
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    openMessageDialog() {
      this.newText = {
        title: "",
        text: "",
      };
      this.messageDialog = true;
    },
    openAddDialog() {
      this.newMember = {
        name: "",
        mobile: "",
        position: "",
        salaryRate: "",
        annualSalary: "",
        hourlySalary: "",
        accountType: "",
        restriction: "none",
        color: "#bf0000",
      };
      this.account = "";
      this.wrongNum = "";
      this.addMemberDialog = true;
    },
    goToPie(item) {
      localStorage.setItem("selectedPie", item.id);
      localStorage.setItem("role", item.userRole);
      // localStorage.setItem("restriction", item.restriction);
      localStorage.setItem("ownerId", item.pieUserId);
      this.role = localStorage.getItem("role");
      this.restriction = localStorage.getItem("restriction");
      this.ownerId = localStorage.getItem("ownerId");
      this.$router.push("/home/" + item.id);
      this.getInfo();
    },
    doReset() {
      this.resetLoading = true;
      this.$http
        .patch(
          this.baseUrl + "/manager/pie/reset/" + this.$route.params.id,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.resetLoading = false;
            this.resetDialog = false;
            this.pieSettingDialog = false;
            this.getInfo();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.resetLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.resetLoading = false;
        });
    },
    openContributionDialog(item) {
      this.selectedType = item;
      setTimeout(() => {
        this.contributionDialog = true;
      }, 300);
    },
    doCloseDialog() {
      this.contributionDialog = false;
    },
    closeMainDialog() {
      this.contributionTypesDialog = false;
    },
    openEditDialog(item) {
      this.accountType = item.accountType;
      this.editMember.id = item.id;
      this.pieSettingDialog = true;
      this.getUserData();
    },
    openEditMemberDialog(item) {
      this.accountType = item.accountType;
      this.editMember.id = item.id;
      this.editMemberDialog = true;
      this.userInfoDialog = false;
      this.getUserData();
    },
    openUserInfoDialog(item) {
      this.selected = item;
      this.accountType = item.accountType;
      this.editMember.id = item.id;
      this.userInfoDialog = true;
      this.getUserData();
    },
    addTag() {
      if (!this.pieDetails.projects.includes(this.pieDetails.tag.trim())) {
        this.pieDetails.projects.push(this.pieDetails.tag.trim());
        this.pieDetails.tag = "";
      } else {
        this.pieDetails.tag = "";
      }
    },
    removeTag(index) {
      this.pieDetails.projects.splice(index, 1);
    },
    addMember() {
      this.busy = true;
      if (this.newMember.salaryRate == "annual") {
        this.newMember.hourlySalary = Number(
          Number(this.newMember.annualSalary) / 2000
        );
      }
      if (!this.newMember.annualSalary) {
        this.newMember.annualSalary = 0;
      }
      if (!this.newMember.hourlySalary) {
        this.newMember.hourlySalary = 0;
      }
      this.$http
        .post(
          this.baseUrl + "/" + this.role + "/pieUser/new",
          {
            name: this.newMember.name,
            mobile: this.newMember.mobile,
            position: this.newMember.position,
            salaryRate: this.newMember.salaryRate,
            annualSalary:
              this.newMember.salaryRate == "annual"
                ? Number(this.newMember.annualSalary)
                : "",
            hourlySalary: Number(this.newMember.hourlySalary),
            accountType: this.newMember.accountType,
            overTime: this.newMember.overTime,
            color: this.newMember.color,
            restriction: this.newMember.restriction,
            pieId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newMember = {
              mobile: "",
              position: "",
              salaryRate: "",
              annualSalary: "",
              hourlySalary: "",
              accountType: "",
              restriction: "none",
            };
            this.getInfo();
            this.addMemberDialog = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    uploadFile(file) {
      let sizeMB = file.size / 1024 / 1024;
      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.isUploading = true;
        this.$http
          .post(
            this.baseUrl +
              "/" +
              this.role +
              "/pie/uploadFile/" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("token"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.pieDetails.mediaId = d.data.id;
              this.pieDetails.mediaUrl = d.data.url;
              this.isUploading = false;
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.isUploading = false;
          });
      }
    },
    getUserData() {
      this.modalLoading = true;
      this.$http
        .get(
          this.baseUrl +
            "/" +
            this.role +
            "/pieUser/getData/" +
            this.editMember.id,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.editMember = res.data;
            this.modalLoading = false;
            setTimeout(() => {
              this.show = true;
            }, 500);
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.modalLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getUserInfo() {
      this.$http
        .get(
          this.baseUrl + "/" + this.role + "/pieUser/getData/" + this.pieUserId,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.userHourlySalary = res.data.hourlySalary;
            this.userOverTime = res.data.overTime;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    doEditMember() {
      this.busy = true;
      if (this.editMember.salaryRate == "annual") {
        this.editMember.hourlySalary = Number(
          Number(this.editMember.annualSalary) / 2000
        );
      }
      if (!this.editMember.annualSalary) {
        this.editMember.annualSalary = 0;
      }
      if (!this.editMember.hourlySalary) {
        this.editMember.hourlySalary = 0;
      }
      this.$http
        .patch(
          this.baseUrl +
            "/" +
            this.role +
            "/pieUser/edit/" +
            this.editMember.id,
          {
            name: this.editMember.userName,
            position: this.editMember.position,
            salaryRate: this.editMember.salaryRate,
            annualSalary:
              this.editMember.salaryRate == "annual"
                ? Number(this.editMember.annualSalary)
                : "",
            hourlySalary: Number(this.editMember.hourlySalary),
            accountType: this.editMember.accountType,
            overTime: this.editMember.overTime,
            restriction: this.editMember.restriction,
            color: this.editMember.color,
            pieId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.getInfo();
            this.editMemberDialog = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    removeMember() {
      this.busy = true;
      if (
        this.removeReason == "Terminate for No Good Reason" ||
        this.removeReason == "Resign for Good Reason"
      ) {
        this.$http
          .patch(
            this.baseUrl +
              "/" +
              this.role +
              "/pieUser/goodinactivate/" +
              this.editMember.id,
            {
              reason: this.removeReason,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            this.busy = false;
            if (res.status == 200) {
              this.toast(res.data.message, "success");
              this.getInfo();
              this.removeMemberDialog = false;
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            this.busy = false;
            this.toast("خطا: " + err.response.data, "error");
          });
      } else {
        this.$http
          .patch(
            this.baseUrl +
              "/" +
              this.role +
              "/pieUser/nogoodinactivate/" +
              this.editMember.id,
            {
              reason: this.removeReason,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            this.busy = false;
            if (res.status == 200) {
              this.toast(res.data.message, "success");
              this.getInfo();
              this.removeMemberDialog = false;
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            this.busy = false;
            this.toast("خطا: " + err.response.data, "error");
          });
      }
    },
    rehireMember() {
      this.rehireBusy = true;
      this.$http
        .patch(
          this.baseUrl + "/" + this.role + "/pieUser/rehire/" + this.deletedId,
          {
            sliceCount: this.rehire.sliceCount
              ? Number(this.rehire.sliceCount)
              : 0,
            wellBalance: this.rehire.wellBalance
              ? Number(this.rehire.wellBalance)
              : 0,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.rehireBusy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.getInfo();
            this.rehireDialog = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.rehireBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    doBuyout(item) {
      this.buyoutBusy = true;
      this.$http
        .post(
          this.baseUrl + "/" + this.role + "/pieUser/buyout/" + item.id,
          {
            well: this.buyoutAmount ? Number(this.buyoutAmount) : 0,
            payFromWell: this.payFromWell,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.buyoutBusy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.getInfo();
            this.buyoutMemberDialog = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.buyoutBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addLumpSum() {
      this.lumpSumBusy = true;
      this.$http
        .post(
          this.baseUrl + "/" + this.role + "/lumpsum/new/" + this.editMember.id,
          {
            date: this.payment.date,
            amount: Number(this.payment.amount),
            description: this.payment.description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.lumpSumBusy = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.payment = {
              date: moment(new Date()).format("jYYYY/jMM/jDD"),
              description: "",
              amount: "",
            };
            this.getInfo();
            this.lumpSumPaymentDialog = false;
            this.editMemberDialog = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.lumpSumBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    openLumpSumDialog() {
      this.getPieData("lumpsum");
      this.payment = {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        description: "",
        amount: "",
      };
      this.lumpSumPaymentDialog = true;
    },
    getPieData(type) {
      // debug
      if (type == "setting") {
        this.file = "";
        this.pieSettingDialog = true;
      }
      this.modalLoading = true;
      this.$http
        .get(
          this.baseUrl +
            "/" +
            this.role +
            "/pie/getData/" +
            this.$route.params.id,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.modalLoading = false;
          if (res.status == 200) {
            this.pieDetails = res.data;
            this.pieDetails.correctionMultiplier = 1000000;
            this.modalLoading = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.modalLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.modalLoading = false;
        });
    },
    doEditPie() {
      this.busy = true;
      if (this.editMember.salaryRate == "annual") {
        this.editMember.hourlySalary = Number(
          Number(this.editMember.annualSalary) / 2000
        );
      }
      this.$http
        .patch(
          this.baseUrl + "/" + this.role + "/pie/edit/" + this.$route.params.id,
          {
            name: this.pieDetails.name,
            valCashMultiplier: Number(this.pieDetails.valCashMultiplier),
            valNonCashMultiplier: Number(this.pieDetails.valNonCashMultiplier),
            valCommission: Number(this.pieDetails.valCommission),
            valRoyalty: Number(this.pieDetails.valRoyalty),
            valFinanceFirst: Number(this.pieDetails.valFinanceFirst),
            valFinanceSecond: Number(this.pieDetails.valFinanceSecond),
            isPieValCar: this.pieDetails.isPieValCar,
            valCarReimbursement: Number(this.pieDetails.valCarReimbursement),
            isPieExtraWork: this.pieDetails.isPieExtraWork,
            valExtraWork: Number(this.pieDetails.valExtraWork),
            valFinanceLimit: Number(this.pieDetails.valFinanceLimit),
            projects: this.pieDetails.projects,
            mediaId: this.pieDetails.mediaId ? this.pieDetails.mediaId : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.pieSettingDialog = false;
            this.getInfo();
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getInfo() {
      this.busy = true;
      this.tab = 0;
      this.$http
        .get(
          this.baseUrl + "/" + this.role + "/pie/home/" + this.$route.params.id,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.allPies = res.data.piesForUser;
            this.pieData = res.data.charts.pieData;
            this.barData = res.data.charts.barData;
            this.chartsInfo = res.data.charts;

            let Users = res.data.pieUsers;
            this.activeUsers = Users.filter((x) => x.status == "active");
            this.inactiveUsers = Users.filter((x) => x.status == "inactive");

            this.role = res.data.userRole;
            this.restriction = res.data.restriction;

            if (this.role != localStorage.getItem("role")) {
              this.getInfo();
            }

            localStorage.setItem("role", this.role);
            localStorage.setItem("restriction", this.restriction);

            this.hasProject = res.data.hasProject;
            if (localStorage.getItem("teamMember")) {
              this.openAddDialog();
              localStorage.removeItem("teamMember");
            } else if (localStorage.getItem("messageToTeam")) {
              this.messageDialog = true;
              localStorage.removeItem("messageToTeam");
            } else if (localStorage.getItem("pieSettings")) {
              this.getPieData("setting");
              localStorage.removeItem("pieSettings");
            }
            setTimeout(() => {
              if (!this.lastVisit) {
                this.tourActive = true;
                this.$tours["myTour"].start();
                let currentTs = this.moment(new Date()).format("X");
                localStorage.setItem("lastVisit", currentTs);
              }
              localStorage.setItem("tour", "done");
            }, "100");

            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          if (err.response.status == 420) {
            if (this.role == "manager") {
              this.role = "employee";
            } else {
              this.role = "manager";
            }
            this.getInfo();
          } else {
            this.toast("خطا: " + err.response.data, "error");
          }
          this.busy = false;
        });
    },
    addFund() {
      this.fundBusy = true;
      this.$http
        .post(
          this.baseUrl +
            "/" +
            this.role +
            "/fundflow/add/" +
            this.$route.params.id,
          {
            description: this.fund.description,
            amount: Number(this.fund.amount),
            fundUserId: this.fund.fundUserId,
            finderId: this.fund.finderId,
            date: this.fund.date,
            managerId: this.ownerId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.fundBusy = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.fund = {
              date: moment(new Date()).format("jYYYY/jMM/jDD"),
              description: "",
              amount: "",
              fundUserId: "",
              finderId: "",
            };
            this.addFundsDialog = false;
            this.getInfo();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.fundBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    drawFund() {
      this.drawBusy = true;
      this.$http
        .post(
          this.baseUrl +
            "/" +
            this.role +
            "/fundflow/withdraw/" +
            this.$route.params.id,
          {
            description: this.drawFundData.description,
            amount: Number(this.drawFundData.amount),
            date: this.drawFundData.date,
            managerId: this.ownerId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.drawBusy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.drawFundData = {
              date: moment(new Date()).format("jYYYY/jMM/jDD"),
              description: "",
              amount: "",
            };
            this.drawFundsDialog = false;
            this.getInfo();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.drawBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    setColor(item) {
      if (item.color) {
        return {
          "--box-color": item.color,
        };
      } else {
        return {
          "--box-color": "#bf0000",
        };
      }
    },
    checkNumber() {
      this.wrongNum = false;
      this.account = "";
      clearInterval(this.interval);
      if (
        (this.newMember.mobile && this.newMember.mobile.length < 11) ||
        this.newMember.mobile.length > 11
      ) {
        this.interval = setInterval(() => {
          this.wrongNum = true;
        }, 1000);
      }
      if (this.newMember.mobile.length == 11) {
        setTimeout(() => {
          this.doCheck();
        }, 1000);
      }
    },
    doCheck() {
      this.$http
        .get(
          this.baseUrl +
            "/" +
            this.role +
            "/user/mobile/" +
            this.newMember.mobile,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.account = "old";
            this.newMember.name = res.data.name;
          } else {
            this.toast(res.data, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.account = "new";
            this.newMember.name = "";
          } else {
            this.toast(err.response.data, "error");
          }
        });
    },
    removePie() {
      this.removeLoading = true;
      this.$http
        .patch(
          this.baseUrl +
            "/" +
            this.role +
            "/pie/delete/" +
            this.$route.params.id,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.removeLoading = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            localStorage.removeItem("selectedPie");
            let link = document.createElement("a");
            link.setAttribute("href", "/home");
            link.click();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.removeLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    endtour() {
      this.tourActive = false;
    },
  },
  computed: {
    menu() {
      return [
        {
          name: "مشاهده گزارش‌ها",
          icon: "mdi-chart-box-outline",
          children: [
            {
              name: "تجزیه و تحلیل",
              icon: "mdi-chart-bar",
              link: "/analytics/" + localStorage.getItem("selectedPie"),
            },
            {
              name: "مشارکت‌ها",
              icon: "mdi-puzzle-outline",
              link: "/contributions/" + this.$route.params.id,
            },
            {
              name: "پرداختی‌های با حجم بالا",
              icon: "mdi-database-outline",
              link: "/lumpSum/" + this.$route.params.id,
            },
            {
              name: "خلاصه",
              icon: "mdi-note-outline",
              link: "/summary/" + this.$route.params.id,
            },
            {
              name: "صندوق مالی",
              icon: "mdi-text-box-outline",
              link: "/wellLog/" + this.$route.params.id,
            },
          ],
        },
        //{
        //  name: "راهنما",
        //  icon: "mdi-help-circle-outline",
        //  children: [
        //    {
        //      name: "راهنمای کاربر",
        //      icon: "mdi-book-open-variant",
        //      link: "",
        //    },
        //    {
        //      name: "تماس با پشتیبانی",
        //      icon: "mdi-forum-outline",
        //      link: "",
        //    },
        //    {
        //      name: "دفترچه راهنما",
        //      icon: "mdi-book-open-outline",
        //      link: "",
        //    },
        //  ],
        //},
      ];
    },
    computedTypes() {
      if (this.pieDetails.isPieValCar == "disablePersonalCar") {
        this.contributionTypes = [
          {
            title: "زمان",
            icon: "mdi-clipboard-clock-outline",
          },
          {
            title: "هزینه‌ها",
            icon: "mdi-currency-usd",
          },
          {
            title: "منابع",
            icon: "mdi-pencil-ruler",
          },
          {
            title: "تجهیزات",
            icon: "mdi-truck-outline",
          },
          {
            title: "فروش",
            icon: "mdi-database-outline",
          },
          {
            title: "حق امتیاز",
            icon: "mdi-head-snowflake-outline",
          },
          {
            title: "امکانات",
            icon: "mdi-domain",
          },
          {
            title: "دستمزد سرمایه‌یاب",
            icon: "mdi-eye-outline",
          },
          {
            title: "سایر موارد",
            icon: "mdi-umbrella-outline",
          },
        ];
      } else {
        this.contributionTypes = [
          {
            title: "زمان",
            icon: "mdi-clipboard-clock-outline",
          },
          {
            title: "هزینه‌ها",
            icon: "mdi-currency-usd",
          },
          {
            title: "منابع",
            icon: "mdi-pencil-ruler",
          },
          {
            title: "تجهیزات",
            icon: "mdi-truck-outline",
          },
          {
            title: "فروش",
            icon: "mdi-database-outline",
          },
          {
            title: "حق امتیاز",
            icon: "mdi-head-snowflake-outline",
          },
          {
            title: "امکانات",
            icon: "mdi-domain",
          },
          {
            title: "دستمزد سرمایه‌یاب",
            icon: "mdi-eye-outline",
          },
          {
            title: "اتومبیل شخصی",
            icon: "mdi-car",
          },
          {
            title: "سایر موارد",
            icon: "mdi-umbrella-outline",
          },
        ];
      }
      return this.contributionTypes;
    },
    computedCurrentPie() {
      if (this.allPies.length) {
        let pie;
        pie = this.allPies.filter((x) => x.id == this.$route.params.id)[0];
        return pie;
      }
    },
    computedPerson() {
      if (
        this.fund.finderId &&
        this.fund.fundUserId &&
        this.fund.fundUserId == this.fund.finderId
      ) {
        return true;
      } else return false;
    },
    computedAmount() {
      if (
        Number(this.drawFundData.amount) > Number(this.chartsInfo.totalWell)
      ) {
        return true;
      } else return false;
    },
    computedAmount2() {
      if (Number(this.rehire.wellBalance) > Number(this.chartsInfo.totalWell)) {
        return true;
      } else return false;
    },
    computedAmount3() {
      if (
        this.payFromWell &&
        Number(this.buyoutAmount) > Number(this.chartsInfo.totalWell)
      ) {
        return true;
      } else return false;
    },
    computedAmount4() {
      if (Number(this.buyoutAmount) > Number(this.selected.buyOutPrice)) {
        return true;
      } else return false;
    },
    computedSumOfWellSlice() {
      let amount;
      amount =
        Math.round(
          Number(this.selected.slices) /
            Number(this.pieDetails.valCashMultiplier)
        ) + Number(this.selected.well);
      return amount;
    },
    computedInvalidAmount() {
      if (this.payment.amount) {
        if (
          Number(this.payment.amount) <=
          Number(this.selected.slices) /
            Number(this.pieDetails.valCashMultiplier) +
            Number(this.selected.well)
        ) {
          if (
            Number(this.payment.amount) >
            Number(this.chartsInfo.totalWell) - Number(this.selected.well)
          ) {
            return true;
          }
        } else return false;
      } else false;
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.restriction = localStorage.getItem("restriction");
    this.ownerId = localStorage.getItem("ownerId");
    this.lastVisit = localStorage.getItem("lastVisit");
    this.getInfo();
    if (window.screen.width < 1264) {
      this.mySteps = this.mobileSteps;
    } else {
      this.mySteps = this.desktopSteps;
    }
  },
};
</script>

<style lang="scss">
// .card-border-right {
//   border-right: 5px solid red;
// }
.v-dialog {
  .logo-box {
    width: 70px;
    height: 70px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 3px;
    }
  }
  .upload-btn {
    border: 1px solid #ccc;
    border-radius: 0 !important;
    position: absolute;
    top: 0;
    left: 0;
    height: 100% !important;
  }
  .v-file-input__text {
    font-weight: 400 !important;
  }
  .contribution-types {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
}

.active-members {
  .member-box {
    border: 1px solid #ccc;
    border-bottom: 0px;
    margin-top: 15px;
    border-top: 6px solid var(--box-color) !important;
    path {
      stroke: var(--box-color) !important;
    }

    .footer {
      background-color: var(--box-color) !important;
    }
    .name {
      color: var(--box-color) !important;
      font-size: 1.1rem;
    }
    .v-progress-linear--reverse .v-progress-linear__background,
    .v-progress-linear--reverse .v-progress-linear__determinate {
      background-color: var(--box-color) !important;
    }
    .image-box {
      width: 100px;
      height: 100px;
      margin: auto;
      margin-top: 25px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.image-box {
  width: 100px;
  height: 100px;
  margin: auto;
  margin-top: 25px;

  img {
    width: 100%;
    height: 100%;
  }
}
.v-step[data-v-54f9a632] {
  background: #fff;
  color: #000;
  border-radius: 5px;
  padding: 0;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

.v-step__button[data-v-54f9a632] {
  background: transparent;
  border: 1px solid #ccc;
  border-radius: 0.1rem;
  color: #000;
}
.v-step__header[data-v-54f9a632] {
  background-color: #fff;
}
.v-step__arrow[data-v-54f9a632]::before {
  background-color: #fff !important;
}
.v-step__content[data-v-54f9a632] {
  border-bottom: 1px solid #ccc;
  color: rgb(90, 90, 90);
  padding: 1rem;
}
.v-step__buttons {
  padding: 0 2rem 1rem 2rem;
}
.v-step__button[data-v-54f9a632] {
  color: rgb(90, 90, 90);
}
.v-step__button-skip[data-v-54f9a632] {
  background-color: red;
  color: #fff;
  border: 1px solid red;
  border-radius: 5px;
}
.v-step__button-skip[data-v-54f9a632]:hover {
  color: red;
}
.v-step__button-next[data-v-54f9a632] {
  background-color: #1e88e5;
  color: #fff;
  border: 1px solid #1e88e5;
  border-radius: 5px;
}
.v-step__button-next[data-v-54f9a632]:hover {
  color: #1e88e5;
}
.v-step__button-previous[data-v-54f9a632] {
  background-color: #90a4ae;
  color: #fff;
  border: 1px solid #90a4ae;
  border-radius: 5px;
}
.v-step__button-previous[data-v-54f9a632]:hover {
  color: #90a4ae;
}
.v-step__button-stop[data-v-54f9a632] {
  background-color: red;
  color: #fff;
  border: 1px solid red;
  border-radius: 5px;
}
.v-step__button-stop[data-v-54f9a632]:hover {
  color: red;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
.v-tour__target--highlighted {
  border-radius: 5px;
  padding: 1rem;
}
.chip-style {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 70px;
  border-radius: 50px;
}
</style>
